import "core-js/modules/es.json.stringify.js";
import { Avatar } from "@element-plus/icons-vue";
import utils from "./plugins/utils";
import { ElMessageBox } from "element-plus";

var md5 = require("@/plugins/md5");

export default {
  data: function data() {
    return {
      utils: null,
      userName: "",
      isShow: true,
      activeIndex: "11",
      dialogVisible: false,
      model: {
        oldPass: "",
        newPass: "",
        confirmPass: ""
      },
      rules: {
        oldPass: utils.EUIRule("required", "旧密码"),
        newPass: utils.EUIRule("required", "新密码"),
        confirmPass: utils.EUIRule("required", "确认新密码")
      }
    };
  },
  components: {
    Avatar: Avatar
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path == "/login" || to.path == "/operation" || to.path == "/selectProduct") {
        this.isShow = false;
      } else {
        this.isShow = true;
      }

      if (!this.userName) {
        this.userName = sessionStorage.getItem("userName");
      }
    }
  },
  created: function created() {
    var _this = this;

    this.utils = utils;
    this.userName = sessionStorage.getItem("userName");
    var activeOps = window.sessionStorage.getItem("activeOps");

    if (activeOps && typeof activeOps == "string") {
      activeOps = JSON.parse(activeOps);
    }

    if (activeOps) {
      this.activeIndex = activeOps.activeIndex;
      this.$router.push(activeOps.path);
    } else {
      this.activeIndex = "11";
      this.$router.push("/index");
    }

    $gb.emitter.on("indexClickMenuItem", function (_ref) {
      var ops = _ref.ops,
          type = _ref.type;

      if (ops) {
        _this.activeIndex = ops.activeIndex;
        window.sessionStorage.setItem("activeOps", JSON.stringify(ops));

        if (type && type === "add") {
          _this.$store.state.isAdd = true;
        } else {
          _this.$store.state.isAdd = false;
        }

        _this.$router.push(ops.path);
      }
    });
  },
  methods: {
    confirm: function confirm() {
      var _this2 = this;

      this.$refs.ruleFormRef.validate(function (valid) {
        if (!valid) {
          $gb.tip("请填写完整表单", "warning");
          return false;
        }

        if (_this2.model.newPass !== _this2.model.confirmPass) {
          $gb.tip("两次密码输入不一致，请重新输入", "warning");
          return false;
        }

        var form = {
          oldPass: md5(_this2.model.oldPass),
          newPass: md5(_this2.model.newPass)
        };
        $api.changePad(form).then(function (res) {
          if (res.statusCode !== 0) {
            $gb.tip(res.msg, "error");
            return false;
          }

          $gb.tip(res.msg);
          _this2.dialogVisible = false;
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("userName");
          _this2.userName = "";

          _this2.resetForm();

          _this2.$router.push("/login");
        });
      });
    },
    resetForm: function resetForm() {
      this.model = {
        oldPass: "",
        newPass: ""
      };
    },
    changePassword: function changePassword() {
      this.dialogVisible = true;
    },
    backIndex: function backIndex() {
      if (utils.UAis("mobile")) {
        this.$router.push("/selectProduct");
      } else {
        this.$router.push("/index");
        this.activeIndex = "11";
        window.sessionStorage.setItem("activeOps", JSON.stringify({
          activeIndex: "11",
          path: "/index"
        }));
      }
    },
    userManage: function userManage() {
      this.$router.push("/userMange");
    },
    menuItem: function menuItem(ops, type) {
      this.activeIndex = ops.activeIndex;
      window.sessionStorage.setItem("activeOps", JSON.stringify(ops));

      if (type === "add") {
        this.$store.state.isAdd = true;
      } else {
        this.$store.state.isAdd = false;
      }
    },
    logOut: function logOut() {
      var _this3 = this;

      ElMessageBox.confirm("是否确认退出登录", "警告", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function (res) {
        window.sessionStorage.removeItem("token");
        window.sessionStorage.removeItem("userName");
        _this3.userName = "";

        _this3.$router.push("/login");
      });
    },
    account: function account() {
      this.$router.push("/userMange");
    }
  }
};